import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=6d0f5b80&scoped=true&"
import script from "./promotions.vue?vue&type=script&lang=js&"
export * from "./promotions.vue?vue&type=script&lang=js&"
import style0 from "./promotions.vue?vue&type=style&index=0&id=6d0f5b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f5b80",
  null
  
)

export default component.exports